import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

/**
 * ОРДЗ.
 */

const initialState: any = '';

export const currentRegionFilterSlice = createSlice({
 name: 'currentRegionFilter',
 initialState,
 reducers: {
  currentRegionFilter: (state, action: PayloadAction<any>) => {
   state = action.payload;
   return state;
  },
 },
});

export const { currentRegionFilter } = currentRegionFilterSlice.actions;

export default currentRegionFilterSlice.reducer;
